// extracted by mini-css-extract-plugin
module.exports = {"addButton":"QualityControl_addButton__VvQLY"};